import { Anchor, Badge, Loader, Stack, Table, Text } from "@mantine/core";
import { useStockAlerts } from "../../../shared/api";
import { EmptyState, PageHeader, formatDateTime } from "../../../shared/ui";

function navigate(page: string, params?: Record<string, any>) {
  window.dispatchEvent(
    new CustomEvent("admin:navigate", { detail: { page, params } }),
  );
}

export function StockAlertsPage() {
  const { data, isLoading } = useStockAlerts();
  const items = data?.results || data || [];

  return (
    <Stack gap="md">
      <PageHeader title="Kritik Stok Alarmları" subtitle="Eşik altı malzemeler" />
      {isLoading ? <Loader /> :
       items.length === 0 ? (
        <EmptyState icon="✅" title="Tüm stok seviyeleri normal" description="Şu an alarm yok" />
      ) : (
        <Table.ScrollContainer minWidth={620}>
          <Table striped highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Tarih</Table.Th>
                <Table.Th>Malzeme</Table.Th>
                <Table.Th>Tür</Table.Th>
                <Table.Th>Severity</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {items.map((a: any) => {
                const isProduct = a.kind === "PRODUCT" && a.product_id;
                const isIngredient = a.kind === "INGREDIENT" && a.ingredient_id;
                const displayName = a.item_name || "(adı yok)";
                return (
                  <Table.Tr key={a.id}>
                    <Table.Td>{formatDateTime(a.created_at)}</Table.Td>
                    <Table.Td>
                      {(isProduct || isIngredient) ? (
                        <Anchor
                          fw={600}
                          onClick={() => navigate("stock-items", {
                            search: displayName,
                            kind: isProduct ? "PRODUCT" : "INGREDIENT",
                          })}
                          style={{ cursor: "pointer" }}
                          title="Stok sayfasında bu kalemi göster"
                        >
                          {displayName}
                        </Anchor>
                      ) : (
                        <Text fw={600}>{displayName}</Text>
                      )}
                    </Table.Td>
                    <Table.Td>
                      <Badge size="xs" variant="light" color={isProduct ? "blue" : "gray"}>
                        {isProduct ? "Ürün" : isIngredient ? "Hammadde" : a.kind || "—"}
                      </Badge>
                    </Table.Td>
                    <Table.Td>
                      <Badge color={a.severity === "OUT_OF_STOCK" ? "red" : a.severity === "CRITICAL" ? "orange" : "yellow"}>
                        {a.severity}
                      </Badge>
                    </Table.Td>
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      )}
    </Stack>
  );
}
